var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 192 192",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dashboard_svg__cls-1",
    d: "M78.07 20.52h-45.7a12 12 0 00-12 12V92.4a12 12 0 0012 12h45.7a12 12 0 0012-12V32.52a12 12 0 00-12-12zm-3.28 68.61H35.65V35.79h39.14zM78.06 123H32.11a12 12 0 00-12 12v25.13a12 12 0 0012 12h46a12 12 0 0012-12V135a12 12 0 00-12.05-12zm-3.33 33.8H35.44v-18.43h39.29zM159.11 88.29h-45.7a12 12 0 00-12 12v59.88a12 12 0 0012 12h45.91a11.79 11.79 0 0011.79-11.78v-60.1a12 12 0 00-12-12zm-3.28 68.61h-39.14v-53.34h39.14zM159.1 20.52h-45.94a12 12 0 00-12 12v25.13a12 12 0 0012 12h45.94a12 12 0 0012-12V32.52a12 12 0 00-12-12zm-3.32 33.8h-39.29V35.85h39.29z"
  })));
}

export default SvgDashboard;